import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { UnitTypeName } from 'services/unitTypes/types';
import { SprayUnitsPerTank } from 'services/sprayEvents/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import Bold from 'components/Bold';
import {
    makeSelectProductRatePerTank,
    makeSelectProductUnitType
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productRatePerTank: SprayUnitsPerTank;
    productUnitType: UnitTypeName;
}

type Props = OwnProps & ConnectedProps;

export class ProductRatePerTankTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productRatePerTank, productUnitType } = this.props;

        return (
            <TableCell>
                <Bold>
                    {productRatePerTank} {productUnitType}
                </Bold>
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productRatePerTank: makeSelectProductRatePerTank(),
    productUnitType: makeSelectProductUnitType()
});

export default connect(mapStateToProps)(ProductRatePerTankTableCellComponent);
